import React from 'react';
import { Box, Button, Grid } from '@mui/material';

const Footer = ({ onCancel, onConfirm }) => {
    return (
        <Box
            sx={{
                padding: '24px',
                background: '#fff',
                width: '100%',
                position: 'sticky',
                bottom: 0,
                zIndex: 10,
                boxShadow: '0px -2px 8px rgba(0, 0, 0, 0.1)',
            }}
        >
            <Grid container justifyContent={'space-between'} spacing={2}>
                <Grid item xs={4} sm={'auto'}>
                    <Button fullWidth color="error" variant="contained" className="btn-text-size-manage" onClick={onCancel}>
                        CANCEL
                    </Button>
                </Grid>
                <Grid item xs={8} sm={'auto'}>
                    <Button fullWidth variant="contained" color="secondary" className="btn-text-size-manage" onClick={onConfirm}>
                        CONFIRM APPOINTMENT
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Footer;
